import { createBlock } from 'factories/block';
import { InteractionProps, repeat } from './interaction';
import { createLayout } from 'factories/layout';
import { colors } from 'styles/variables';
import { createContinueBtn } from './continueBtn';
import { createEditableBtn } from './editableBtn';
import uuid from 'uuidv4';
import { getSId } from '../utils';

const { lPink } = colors;

// - Interaction
//   - Row
//     - Column
//       - FiveStarRating
//         - FiveStarList
//           - Star (repeat)
//         - TextArea
//         - SubmitButton
//     - Column
//       - Text
//   - Row
//     - Column
//       - ContinueButton (repeat)

export type FiveStarRatingInteractionProps = InteractionProps & {
  //
};

export const createFiveStarRatingBlock = (count: number) => {
  return createBlock('FiveStarRating', [
    createBlock('FiveStarList', [
      ...repeat(() => createBlock('Star'), count || 5),
    ]),
    createBlock('TextArea'),
    createEditableBtn({ label: 'Submit' }),
    createBlock('FeedbackSubmitted', [
      createBlock('Image'),
      createBlock('Text'),
    ]),
  ]);
};

const contentForColumn = (count: number) => (i: number) => {
  return [
    () => createBlock('Text', [], { props: { useBackgroundControls: true } }),
    () => createFiveStarRatingBlock(count),
  ][i];
};

export const createFiveStarRatingInteractionBlock = (
  props: FiveStarRatingInteractionProps
) => {
  const {
    starColor = lPink,
    submissionEmailDestination = '',
    subject = '',
    lockDown = 0,
    style,
  } = props as any;

  return createBlock(
    'Interaction',
    [
      createLayout(contentForColumn(0), 0, true),
      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'FiveStarRating',
        name: props.name,
        sId: getSId('interaction'),
        style: props.style,
        starColor,
        submissionEmailDestination,
        subject,
        lockDown,
      },
      meta: {
        subType: 'FiveStarRating',
        layout: 'OneColumnReversed',
      },
    }
  );
};

export const create = createFiveStarRatingInteractionBlock;
export const interactionConfig = {};
